import React, {useEffect, useState} from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import {SortableTreeItemCard} from './SortableTreeItemCard.tsx';
import {flattenTreeAll as flattenTree, setProperty} from './Tree/utilities.ts';
import saveTaskItemsToLocalStorage from './dbUtils.js';
import './App.css';

const states = [
  { id: 1, name: 'New' },
  { id: 2, name: 'Processing' },
  { id: 3, name: 'Ready' },
  { id: 4, name: 'Scheduled' },  
  { id: 5, name: 'In Progress' },  
  { id: 6, name: 'Completed' },
]

const primaryLabels = [
  { id: 1, name: 'None' },
  { id: 2, name: 'Career' },
  { id: 3, name: 'Finances' },
  { id: 4, name: 'Health' },
  { id: 5, name: 'Interests' },
  { id: 6, name: 'Knowledge' },  
  { id: 7, name: 'Lifestyle' },
  { id: 8, name: 'Organisation' },
  { id: 9, name: 'Social' }, 
  { id: 10, name: 'Relationships' },
]

  function areDatesMoreThanOneDayApart(date1, date2) {
  // Ensure both inputs are valid Date objects
  if (!(date1 instanceof Date) || !(date2 instanceof Date)) {
    throw new Error("Inputs must be valid Date objects.");
  }

  // Calculate the difference in milliseconds
  const diffInMilliseconds = Math.abs(date1.getTime() - date2.getTime());

  // Convert milliseconds to days (1 day = 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
  const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
  const diffInDays = diffInMilliseconds / oneDayInMilliseconds;

  // Return true if the difference is greater than 1 day
  return diffInDays > 1;
  }

function UtilitySidebar({
  items,
  setItems,
  selectedItem,
  // setSelectedItem
}) {
      let internalStatus;
      if(selectedItem?.status) {
        console.log('Do we get here?: 0');
        internalStatus = states.find(({name}) => name === selectedItem.status);
        console.log('Status passed in in treeitem: '+internalStatus?.name);
        if(internalStatus === undefined){
          // setSelectedPrimaryLabel(internalPrimaryLabel);
          // return internalPrimaryLabel;
          internalStatus = states[0]; //TODO: Not sure what this is.
          console.log('Do we get here?: 1');
        }
      }
      else {
        console.log('Do we get here?: 2');
        internalStatus = states[0]; //TODO: Not sure what this is.
      }

      let internalPrimaryLabel;
      if(selectedItem?.primaryLabel) {
        internalPrimaryLabel = primaryLabels.find(({name}) => name === selectedItem.primaryLabel);
        console.log('Primary label passed in in treeitem: '+internalPrimaryLabel?.name);
        if(internalPrimaryLabel === undefined){
          // setSelectedPrimaryLabel(internalPrimaryLabel);
          // return internalPrimaryLabel;
         internalPrimaryLabel = primaryLabels[0];
        }
      }
      else {
        internalPrimaryLabel = primaryLabels[0];
      }

  console.log('Do we get here?: z '+internalStatus.name);
  console.log('Do we get here?: z'+internalPrimaryLabel.name);

  const initialStatus = internalStatus;
  const initialLabel = internalPrimaryLabel;
  // const [navMenuCollapsed, setNavMenuCollapsed] = React.useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(true);
  const [itemToDisplayStatus, setItemToDisplayStatus] = React.useState(initialStatus);
  const [itemToDisplayPrimaryLabel, setItemToDisplayPrimaryLabel] = React.useState(initialLabel);


      useEffect(() => {

      let newInternalStatus;
      if(selectedItem?.status) {
        console.log('Do we get here?: 0');
        newInternalStatus = states.find(({name}) => name === selectedItem.status);
        console.log('Status passed in in treeitem: '+newInternalStatus?.name);
        if(newInternalStatus === undefined){
          // setSelectedPrimaryLabel(internalPrimaryLabel);
          // return internalPrimaryLabel;
          newInternalStatus = states[0]; //TODO: Not sure what this is.
          console.log('Do we get here?: 1');
        }
      }
      else {
        console.log('Do we get here?: 2');
        newInternalStatus = states[0]; //TODO: Not sure what this is.
      }

      let newInternalPrimaryLabel;
      if(selectedItem?.primaryLabel) {
        newInternalPrimaryLabel = primaryLabels.find(({name}) => name === selectedItem.primaryLabel);
        console.log('Primary label passed in in treeitem: '+newInternalPrimaryLabel?.name);
        if(newInternalPrimaryLabel === undefined){
          // setSelectedPrimaryLabel(internalPrimaryLabel);
          // return internalPrimaryLabel;
         newInternalPrimaryLabel = primaryLabels[0];
        }
      }
      else {
        newInternalPrimaryLabel = primaryLabels[0];
      }

        const newInternalStatus2 = newInternalStatus;
      const newInternalPrimaryLabel2 = newInternalPrimaryLabel;
        setItemToDisplayStatus(newInternalStatus2);
        setItemToDisplayPrimaryLabel(newInternalPrimaryLabel2);
      }, [selectedItem]);

  console.log('Do we get here?: '+items);

  console.log('Do we get here?: '+itemToDisplayStatus.name);
  console.log('Do we get here?: '+itemToDisplayPrimaryLabel.name);

  // function handleLogOutCLick() {
  //   localStorage.setItem("Authenticated", false);
  //   console.log('setIsLoggedIn: ' + setIsLoggedIn);
  //   setIsLoggedIn(false);
  // }
  const itemToDisplay = getItemToDisplay();

  return (
        <div className="App-UtilitySidebar">
          <button className="sb-button" onClick={() => setSidebarCollapsed(!sidebarCollapsed)}>
            {sidebarCollapsed && "|<"} {!sidebarCollapsed && ">|"}
          </button>
          <Sidebar collapsed={sidebarCollapsed} collapsedWidth="5px" width="500px" rtl={true}>
            <div>
                        {itemToDisplay && <SortableTreeItemCard
                          selectedStatus={itemToDisplayStatus}
                          onSelectedStatusChanged={setItemToDisplayStatus}
                          selectedPrimaryLabel={itemToDisplayPrimaryLabel}
                          onSelectedPrimaryLabelChanged={setItemToDisplayPrimaryLabel}
                          dir="ltr"                          
                          key={itemToDisplay.id}
                          id={itemToDisplay.id}
                          value={itemToDisplay.title ? itemToDisplay.title: itemToDisplay.id.toString()}
                          inputRef={null} 
                          // {id === focusToTreeItemId ? titleInputRef : null}
                          estimatedCommencementDate={itemToDisplay.estimatedCommencementDate}
                          idealCompletionDate={itemToDisplay.idealCompletionDate}
                          latestPossibleCompletionDate={itemToDisplay.latestPossibleCompletionDate}
                          done={itemToDisplay.done}
                          depth={0}
                          draggable={false}
                          // {id === activeId && projected ? projected.depth : depth}
                          goal={itemToDisplay.goal}
                          indentationWidth={0}
                          // {indentationWidth}
                          indicator={false}
                          // {indicator}
                          primaryLabel={itemToDisplay.primaryLabel}
                          status={itemToDisplay.status}
                          collapsed={null} /*{Boolean(collapsed && children.length)} */
                          onCollapse={null}
                          // {
                          //   collapsible && children.length
                          //     ? () => handleCollapse(id)
                          //     : undefined
                          // }
                          onDoneChanged={null} /*{() => handleDone(id)}*/
                          onGoalChanged={null}
                          // {() => handleGoal(itemToDisplay.id)}
                          insertNewItemAfter={null} 
                          // {(ctrlCreate) => insertNewItemAfter(itemToDisplay.id, ctrlCreate)}
                          onEstimatedCommencementDateChanged={(newDate) => handleOnEstimatedCommencementDateChanged(itemToDisplay.id, newDate)}
                          onIdealDateChanged={(newDate) => handleOnIdealDateChanged(itemToDisplay.id, newDate)}
                          onLatestDateChanged={null}
                          // {(newDate) => handleOnLatestDateChanged(itemToDisplay.id, newDate)}
                          onPrimaryLabelChanged={(newPrimaryLabel) => handleOnPrimaryLabelChanged(itemToDisplay.id, newPrimaryLabel)}
                          onStatusChanged={(newStatus) => handleOnStatusChanged(itemToDisplay.id, newStatus)}
                          onTitleChanged={(newTitle, focussedValue) => handleOnTitleChanged(itemToDisplay.id, newTitle, focussedValue)}
                          onRemove={null}
                          // {true ? () => handleRemove(itemToDisplay.id) : undefined}
                          onNavTo={null}
                          // {() => handleNavToItem(itemToDisplay.id)}
                        >{itemToDisplay && console.log('Item to display in sidebar from card render: '+itemToDisplay.title + ' '+itemToDisplay.title+' '+itemToDisplay.primaryLabel+' '+itemToDisplay.status)}</SortableTreeItemCard>}

            </div>
          </Sidebar>
        </div>
  );

  function getItemToDisplay() {

    let itemToDisplay = null;

    if(items) {

      const flattenedItems = flattenTree(items);

      itemToDisplay = selectedItem?.id
        ? flattenedItems.find(({ id }) => id === selectedItem.id)
        : null;
    }

    itemToDisplay && console.log('Item to display in sidebar from sidebar initialisation.: '+itemToDisplay.title + ' '+itemToDisplay.title+' '+itemToDisplay.primaryLabel+' '+itemToDisplay.status);
      // itemToDisplay && setItemToDisplayStatus(itemToDisplay.status);
      // itemToDisplay && setItemToDisplayPrimaryLabel(itemToDisplay.primaryLabel);
    return itemToDisplay;
  }

  function handleOnIdealDateChanged(thisId, newDateTime) {
    console.log("is handling 'onIdealDateChanged' working from card??");
    setItems((items) =>
      setProperty(items, thisId, 'idealCompletionDate', (aDate) => {//TODO: WTF is going on here?!...
        console.log("is setting 'idealCompletionDate' working?? "+thisId+' '+newDateTime);

        setProperty(items, thisId, 'start',  (oldDate) => {//TODO: WTF is going on here?!...
          const newScheduledStartDate = new Date((new Date(newDateTime)).toUTCString());
          console.log("is setting 'start' working?? "+thisId+' '+new Date(newDateTime+'Z'));
          return newScheduledStartDate;

          });

          const thisItem = flattenTree(items).find(({id}) => id === thisId);
          if(areDatesMoreThanOneDayApart(new Date(thisItem['start']), new Date(thisItem['end']) )) {
                    setProperty(items, thisId, 'allDay',  () => {
                        console.log("is setting 'allDay' working?? "+thisId);
                        return true;
                    });
          }
          else {
              setProperty(items, thisId, 'allDay',  () => {
                console.log("is setting 'allDay' working?? "+thisId);
                return false;
              });
          }
        return newDateTime;
      })
    );
    saveTaskItemsToLocalStorage(items);
    console.log("What's the time MOFO!"+newDateTime);
    // console.log("What's the time MOFO!"+newScheduledStartDate);
    console.log("Handling 'onIdealDateChanged' from card complete.");
  }

      function handleOnEstimatedCommencementDateChanged(thisId, newDateTime) {
      console.log("is handling 'onEstimatedCommencementDateChanged' working??");
      setItems((items) =>
        setProperty(items, thisId, 'estimatedCommencementDate', (aDate) => {//TODO: WTF is going on here?!...
          console.log("is setting 'estimatedCommencementDate' working?? "+thisId+' '+newDateTime);
  
          setProperty(items, thisId, 'start',  (oldDate) => {//TODO: WTF is going on here?!...
            const newScheduledStartDate = new Date((new Date(newDateTime)).toUTCString());
            console.log("is setting 'start' working?? "+thisId+' '+new Date(newDateTime+'Z'));
            return newScheduledStartDate;
  
            });
  
          // const thisItem = flattenTree(items).find(({id}) => id === thisId);
          //   if(areDatesMoreThanOneDayApart(new Date(thisItem['start']), new Date(thisItem['end']) )) {
                      // setProperty(items, thisId, 'allDay',  () => {
                      //     console.log("is setting 'allDay' working?? "+thisId);
                      //     return true;
                      // });
          //   }
          //   else {
          //       setProperty(items, thisId, 'allDay',  () => {
          //         console.log("is setting 'allDay' working?? "+thisId);
          //         return false;
          //       });
          //   }
          return newDateTime;
        })
      );
      saveTaskItemsToLocalStorage(items);
      console.log("What's the time MOFO!"+newDateTime);
      // console.log("What's the time MOFO!"+newScheduledStartDate);
      console.log("Handling 'onEstimatedCommencementDateChanged' complete.");
    }

      function handleOnLatestDateChanged(thisId, newDateTime) {
        console.log("is handling 'onLatestDateChanged' working??");
        setItems((items) =>
          setProperty(items, thisId, 'latestPossibleCompletionDate', (aDate) => {
            console.log("is setting 'latestPossibleCompletionDate' working?? "+thisId+' '+newDateTime);
    
            setProperty(items, thisId, 'end',  (oldDate) => {//TODO: WTF is going on here?!...
              const newScheduledEndDate = new Date((new Date(newDateTime)).toUTCString());
              console.log("is setting 'end' working?? "+thisId+' '+new Date(newDateTime+'Z'));
              return newScheduledEndDate;
    
              });
              
              const thisItem = flattenTree(items).find(({id}) => id === thisId);
              if(areDatesMoreThanOneDayApart(new Date(thisItem['start']), new Date(thisItem['end']) )) {
                        setProperty(items, thisId, 'allDay',  () => {
                          console.log("is setting 'allDay' working?? "+thisId);
                          return true;
                        });
              }
              else {
                  setProperty(items, thisId, 'allDay',  () => {
                    console.log("is setting 'allDay' working?? "+thisId);
                    return false;
                  });
              }
            return newDateTime;
          })
        );
        saveTaskItemsToLocalStorage(items);
        console.log("Handling 'onLatestDateChanged' complete.");
      }

        function handleOnPrimaryLabelChanged(id, newPrimaryLabel) {
          console.log("is handling 'onPrimaryLabelChanged' working??");
          setItems((items) =>
            setProperty(items, id, 'primaryLabel', () => {
              console.log("is setting 'primaryLabel' working?? "+id+' '+newPrimaryLabel);
                return newPrimaryLabel;
            })
          );
          saveTaskItemsToLocalStorage(items);
          console.log("Handling 'onPrimaryLabelChanged' complete.");
        }
      
        function handleOnStatusChanged(id, newStatus) {
          console.log("is handling 'onStatusChanged' working??");
          setItems((items) =>
            setProperty(items, id, 'status', () => {
              console.log("is setting 'status' working?? "+id+' '+newStatus);
                return newStatus;
            })
          );
          saveTaskItemsToLocalStorage(items);
          console.log("Handling 'onStatusChanged' complete.");
        }

          function handleOnTitleChanged(changedId, newTitle, focussedValue) {
            // console.log("is handling 'onTitleChanged' working??");
        
            const flattenedItems = flattenTree(items);
        
            // if(focussedValue) {
            //   let newFocusItem = flattenedItems.find(({title}) => title === focussedValue);
            //   if(newFocusItem){
            //     setFocusToTreeItemId(newFocusItem['id']);
            //   }
            //   else {
            //     newFocusItem = flattenedItems.find(({id}) => id === focussedValue);
            //     if(newFocusItem){
            //       setFocusToTreeItemId(newFocusItem['id']);
            //     }
            //   }
            // };
        
            if(flattenedItems.find(({id}) => id === changedId)['title'] === newTitle) {
        
            }
            else {
              setItems((items) =>
                setProperty(items, changedId, 'title', (aDate) => {
                  console.log("is setting 'title' working?? "+changedId+' '+newTitle);
                    return newTitle;
                })
              );
        
              saveTaskItemsToLocalStorage(items);
        
            };
        
          }
}

export default UtilitySidebar;
